<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>租赁管理</el-breadcrumb-item>
      <el-breadcrumb-item>账单管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.billName" placeholder="输入账单名称"></el-input>
      </el-form-item>
      <el-form-item  label="状态">
        <el-select v-model="formInline.state" placeholder="请选择状态" size="small" clearable >
          <el-option :value="0" label="未结清"></el-option>
          <el-option :value="1" label="已结清"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="user.username == 'admin'" label="选择部门">
        <el-select v-model="formInline.depId" placeholder="请选择部门" size="small" >
          <el-option v-for="item in deptList" :key="item.id" :label="item.departmentName" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker type="month" size="small" value-format="yyyy-MM" v-model="formInline.monthDate"
          >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>

      </el-form-item>

    </el-form>

    <el-table :header-cell-style="this.$store.state.headerCss" size="small" :data="dataList" highlight-current-row
      v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" stripe :max-height="tableHeight">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>

      <el-table-column prop="billName" label="账单名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="roomName" label="房间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="monthDate" label="结算月份" show-overflow-tooltip>
      </el-table-column>
      
      
      <el-table-column prop="stateDate" label="开始时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="endDate" label="结束时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="userName" label="承租人" show-overflow-tooltip>
      </el-table-column>
      
      
      <el-table-column prop="powerTotalValue" label="用电量" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="waterTotalValue" label="用水量" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="roomRent" label="房间租金" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="powerMoney" label="电费金额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="waterMoney" label="水费金额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="managementMoney" label="管理费" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="healthMoney" label="卫生费" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="elevatorMoney" label="电梯费" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="状态" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state" type="success" size="mini">已结清</el-tag>
          <el-tag v-else size="mini" type="danger">未结清</el-tag>
        </template>

      </el-table-column>
      <el-table-column prop="totalMoney" label="合计金额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="receivedMoney" label="已收金额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="notNeceivedMoney" label="未收金额" show-overflow-tooltip>
      </el-table-column>


      <el-table-column align="center" label="操作" width="100">
        <template slot-scope="scope">
          <prems-button size="mini"  type="warning"  perms="p:detail" @click="handleEdit(scope.row)" label="编辑" />
        <!--  <prems-button size="mini" type="danger" perms="p:delete" @click="deleteInfo(scope.row)" label="删除" />
 -->
          <!--   <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger"    @click="deleteInfo(scope.row)">删除</el-button>
          <el-button size="mini" type="primary"   @click="handleRecharge(scope.$index, scope.row,'1')">充值</el-button>
          <el-button size="mini" type="warning"   @click="handleRecharge(scope.$index, scope.row,'2')">退款</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="formInline" @callFather="callFather" v-if="showPage"></Pagination>



    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="editFormVisible = false">
      <el-form label-width="120px" :model="editForm" ref="editForm">
       <!-- <el-form-item v-if="user.username == 'admin'" label="部门">
          <el-select v-model="this.editForm.depId" placeholder="请选择部门" size="small"  disabled>
            <el-option v-for="item in deptList" :key="item.id" :label="item.departmentName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item> -->

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="账单名称" prop="rent">
              <el-input size="small" v-model="editForm.billName" auto-complete="off" placeholder="请输入租金" disabled></el-input>
            </el-form-item>
            <el-form-item label="结算月份">

              <el-input size="small" v-model="editForm.monthDate"  disabled></el-input>
            </el-form-item>
            <el-form-item label="用电量">
              <el-input size="small" v-model="editForm.powerTotalValue" auto-complete="off" ></el-input>
            </el-form-item>

            <el-form-item label="用水量">
              <el-input size="small" v-model="editForm.waterTotalValue" auto-complete="off" placeholder="请输入用水量"></el-input>
            </el-form-item>


            <el-form-item label="房间租金">
              <el-input size="small" v-model="editForm.roomRent"  auto-complete="off" ></el-input>
            </el-form-item>
            <el-form-item label="电费金额">
              <el-input size="small" v-model="editForm.powerMoney"  auto-complete="off"  placeholder="请输入电费金额"></el-input>
            </el-form-item>
            <el-form-item label="水费金额">
              <el-input size="small" v-model="editForm.waterMoney" auto-complete="off"  placeholder="请输入水费金额"></el-input>
            </el-form-item>

          </el-col>

          <el-col :span="12">

            <el-form-item label="管理费">
              <el-input size="small" v-model="editForm.managementMoney"   auto-complete="off" placeholder="请输入管理费"></el-input>
            </el-form-item>
            <el-form-item label="卫生费">
              <el-input size="small" v-model="editForm.healthMoney"   auto-complete="off" placeholder="请输入卫生费"></el-input>
            </el-form-item>

            <el-form-item label="电梯费">
              <el-input size="small" v-model="editForm.elevatorMoney"   auto-complete="off" placeholder="请输入电梯费"></el-input>
            </el-form-item>
            <el-form-item label="合计金额">
              <el-input size="small" v-model="editForm.totalMoney"   auto-complete="off" placeholder="请输入合计金额"></el-input>
            </el-form-item>

            <el-form-item label="已收金额">
              <el-input size="small" v-model="editForm.receivedMoney"   auto-complete="off" placeholder="请输入已收金额"></el-input>
            </el-form-item>
            <el-form-item label="未收金额">
              <el-input size="small" v-model="editForm.notNeceivedMoney"   auto-complete="off" placeholder="请输入未收金额"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="setLoading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>




  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import PremsButton from "@/views/permission/PreButtom";
  import {
    getDepartmentTerminalInfoLis
  } from '../../api/energyMG'
  import {
    findRoomMonthBillList,
    modifyRoomMonthBill,
  } from '../../api/payMG.js'

  export default {
    data() {


      return {
        formInline: {
          pageSize: 10,
          currentPage: 1,
          state:'',
          total: 0,
          depId: "",
          roomName: "",
          monthDate: "2021-07",
          contractName: "",
          billName: ""
        },
        saveLoad: false,
        totalFee: "",
        users: [],
        editForm: {
          billName: "",
          monthDate: "",
          powerTotalValue: "",
          waterTotalValue: "",
          roomRent: "",
          powerMoney: "",
          waterMoney: "",
          managementMoney: "",
          healthMoney: "",
          elevatorMoney: "",
          totalMoney: "",
          receivedMoney: "",
          notNeceivedMoney: "",
          depId:"",

        },
        pageparm: {

        },
        rtitle: "",
        rechargeFormVisible: false,
        setLoading: false,
        tableHeight: 0,
        title: "",
        loading: false,
        meterPointName: "",
        editFormVisible: false,
        dataList: [],
        deptList: [],
        user: {},
        showPage: true,
        reditForm: {
          totalFee: "",
          appletUserId: '',
          roomId: "",
          mark: "",
          roomType: "63",
          payType: '2',
        },
        dayStr: [],

        money: {
          water: '',
          wuYe: "",
        },

        rules: {
          rent: [{
            required: true,
            message: '请输入租金',
            trigger: 'blur'
          }],
          roomContractId: [{
            required: true,
            message: '请选择合同',
            trigger: 'change'
          }],
          startTime: [{
            required: true,
            message: '开始时间不能为空',
            trigger: 'change'
          }],
          endTime: [{
            required: true,
            message: '结束时间不能为空',
            trigger: 'change'
          }],

          // roomNum:[{validator:validatePass,trigger:'change' }]

        },

        ContractList: [],
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight - 300
      })
    },
    created() {
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      this.departmentId = JSON.parse(sessionStorage.getItem('userdata')).departmentId
      if (this.user.username != 'admin') {
        this.formInline.depId = JSON.parse(sessionStorage.getItem('userdata')).departmentId

      }

      this.getData()
      this.getJzData()

    },
    components: {
      Pagination,
      PremsButton
    },
    methods: {
      getDay(e) {
        this.formInline.startTime = e[0]
        this.formInline.endTime = e[1]
        this.getData()

      },

      getJzData: function() {
        return new Promise((resolve, reject) => {
          getDepartmentTerminalInfoLis().then(res => {
            this.treeLoad = false
            if (res.status == 1) {
              let arr = []
              this.deptList = res.data.menuDepList

            } else {
              this.$message.error(res.msg)
            }
          })
        })

      },





      changeType(e) {
        if (this.reditForm.roomType == '63') {
          this.dForm.blance = this.money.water
        } else {
          this.dForm.blance = this.money.wuYe
        }
      },


      getData() {
        this.loading = true
        findRoomMonthBillList(this.formInline).then(res => {
          this.loading = false
          if (res.status == 1) {
            this.dataList = res.data.data
            this.formInline.total = res.data.totalCount

          } else {
            this.$message.error(res.msg)
          }
        })
      },

      handleEdit(row) {
        this.title = '编辑'

        this.editFormVisible = true
        this.editForm.id = row.id
        this.editForm.billName = row.billName
        this.editForm.monthDate = row.monthDate
        this.editForm.powerTotalValue = row.powerTotalValue
        this.editForm.waterTotalValue = row.waterTotalValue
        this.editForm.roomRent = row.roomRent
        this.editForm.powerMoney = row.powerMoney
        this.editForm.waterMoney = row.waterMoney
        this.editForm.managementMoney = row.managementMoney
        this.editForm.healthMoney = row.healthMoney
        this.editForm.elevatorMoney = row.elevatorMoney
        this.editForm.totalMoney = row.totalMoney
        this.editForm.receivedMoney = row.receivedMoney
        this.editForm.notNeceivedMoney = row.notNeceivedMoney

        this.editForm.depId = row.departmentId




      },
      search() {
        this.getData()
      },
      callFather(parm) {
        this.formInline.currentPage = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getData()
      },




      submitForm() {

        this.$refs['editForm'].validate(valid => {

          if (valid) {
            if (this.title == '添加') {
              this.add()
            } else {
              this.update()
            }
          }
        })


      },


      update() {
        this.setLoading = true
        modifyRoomMonthBill(this.editForm).then(res => {
          this.setLoading = false
          if (res.status == 1) {
            this.editFormVisible = false
            this.$message.success("操作成功")
            this.getData();
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/property/zd.vue